import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";
import { IoAlertCircleSharp } from "react-icons/io5";
import useAuth from "../useAuth";
import Loading from "../Components/global/Loading";
import { Paper } from "@mui/material";
import { useForm } from "react-hook-form";

export default function Register() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const { user, authMessage, loading, registerWithEmailAndPassword } =
    useAuth();

  const handleRegister = async (data) => {
    registerWithEmailAndPassword(
      data?.name,
      data?.mobile,
      data?.email,
      data?.password
    );
  };

  if (user) {
    return <Navigate to="/my/" />;
  }

  return (
    <div className="flex bg-gray-100 min-h-[100vh] items-center justify-center">
      <Paper className="p-6 w-[70%]" sx={{ borderRadius: 5 }}>
        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-5 flex items-center flex-col justify-center">
            <img
              className="p-10 w-full h-40"
              src="/assets/svg/logo.svg"
              alt="logo"
            />

            <div>
              <h1 className="text-2xl font-bold text-center text-gray-400">
                Register with Fewmax to access Admin Panel
              </h1>
            </div>
          </div>
          <div className="h-full w-[1px] bg-primaryLight rounded-full" />
          <form onSubmit={handleSubmit(handleRegister)} className="col-span-5">
            <p className="text-primary font-semibold mb-4 text-lg">
              Start Your Journey with Fewmax
            </p>
            <div className="mt-6">
              <div className="h-20">
                <p className="text-xs">Enter Your Name</p>
                <input
                  className={`border rounded-lg w-full text-sm ${
                    errors?.name?.message
                      ? "bg-rose-50 border-rose-300 focus:outline-rose-600"
                      : "focus:outline-primary border-gray-300"
                  }`}
                  placeholder="Enter your name"
                  {...register("name", {
                    required: "Please enter your name",
                    minLength: {
                      value: 3,
                      message: "Name must be at least 3 characters",
                    },
                  })}
                />
                <p className="text-rose-600 text-xs">{errors?.name?.message}</p>
              </div>

              <div className="h-20">
                <p className="text-xs">Enter Your Mobile Number</p>
                <input
                  className={`border rounded-lg w-full text-sm ${
                    errors?.mobile?.message
                      ? "bg-rose-50 border-rose-300 focus:outline-rose-600"
                      : "focus:outline-primary border-gray-300"
                  }`}
                  placeholder="Enter mobile number"
                  {...register("mobile", {
                    required: "Please enter your mobile number",
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "Please enter a valid 10-digit mobile number",
                    },
                  })}
                />
                <p className="text-rose-600 text-xs">
                  {errors?.mobile?.message}
                </p>
              </div>

              <div className="h-20">
                <p className="text-xs">Enter Your Email</p>
                <input
                  className={`border rounded-lg w-full text-sm ${
                    errors?.email?.message
                      ? "bg-rose-50 border-rose-300 focus:outline-rose-600"
                      : "focus:outline-primary border-gray-300"
                  }`}
                  placeholder="Enter full name"
                  {...register("email", {
                    required: "Please enter your email address",
                    pattern: {
                      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                      message: "Please enter a valid email address",
                    },
                  })}
                />
                <p className="text-rose-600 text-xs">
                  {errors?.email?.message}
                </p>
              </div>

              <div className="h-20">
                <p className="text-xs">Enter Your Password</p>
                <input
                  className={`border rounded-lg w-full text-sm ${
                    errors?.password?.message
                      ? "bg-rose-50 border-rose-300 focus:outline-rose-600"
                      : "focus:outline-primary border-gray-300"
                  }`}
                  placeholder="Enter full name"
                  {...register("password", {
                    required: "Please enter your password",
                    minLength: {
                      value: 8,
                      message: "Password must be at least 8 characters long",
                    },
                    pattern: {
                      value:
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                      message:
                        "Password must include uppercase, lowercase, number, and special character",
                    },
                  })}
                />
                <p className="text-rose-600 text-xs">
                  {errors?.password?.message}
                </p>
              </div>

              <br />
            </div>
            <div className="text-center text-red-500 capitalize flex justify-center items-center gap-2">
              {authMessage && (
                <div className="text-xl">
                  <IoAlertCircleSharp />
                </div>
              )}
              {authMessage?.slice(5).split("-").join(" ")}
            </div>
            <div className="">
              <button
                type="submit"
                className="bg-primary flex shadow-md gap-2 items-center text-white w-full rounded-full px-6 text-sm py-2 justify-center hover:bg-primaryDark duration-500"
              >
                Register
                <BsArrowRight />
              </button>
            </div>

            <div className="mt-4 flex items-center justify-center gap-2">
              Already have an account?
              <p
                className="text-primary cursor-pointer font-semibold"
                onClick={() => navigate("/login")}
              >
                Login Now
              </p>
            </div>
          </form>
        </div>
      </Paper>
      {loading && <Loading />}
    </div>
  );
}
